import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import MapWrapper from './../map/MapWrapper';
import VideoWrapper from '../grid/videoWrapper/VideoWrapper';
import TilesGallery from '../grid/tilesGalleryWrapper/TilesGalleryWrapper';
import ModeButtonsContainer from './../rightPanelContent/ModeButtonsContainer';
import ModelWrapper from '../grid/modelWrapper/ModelWrapper';
import StreamWrapper from '../grid/streamWrapper/StreamWrapper';

const MainContentStyled = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`

const TobBarStyled = styled.div`
    display: flex;  
    width: 100%;
    height: 60%;
`

const MapStyled = styled.div`
    display: flex;
    width: 100%;
`

export class MainContent extends React.Component<Props, State> {
    componentDidUpdate(): void {
        this.props.resizeObservable.fireCallbacks();
    }

    render() {
        const { selected } = this.props;
        return (
            <MainContentStyled>
                <ModeButtonsContainer />
                {selected === 'gallery' &&
                    <TobBarStyled>
                        <TilesGallery childProps=
                            {{
                                photosDirection: 3,
                                resizeObservable: this.props.resizeObservable,
                            }}
                        />
                    </TobBarStyled>}
                {selected === 'video' &&
                    <TobBarStyled>
                        <VideoWrapper />
                    </TobBarStyled>}
                {selected === 'model' &&
                    <TobBarStyled>
                        <ModelWrapper />
                    </TobBarStyled>}
                {selected === 'stream' && 
                    <TobBarStyled>
                        <StreamWrapper />
                    </TobBarStyled>}
                <MapStyled style={{ height: selected === 'default' || selected === 'resource' ? '100%' : '40%' }} >
                    <MapWrapper resizeObservable={this.props.resizeObservable} />
                </MapStyled>
            </MainContentStyled>
        );
    }
};

const mapStateToProps = state => ({
    selected: state.modules.get('selected')
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MainContent);


// WEBPACK FOOTER //
// ./src/containers/content/mainContent/MainContent.jsx